module.exports = __webpack_public_path__ + "img/blue_083.6ae683fa.png";